var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcFillBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 16.612c0 1.121-1.214 1.778-2.097 1.135l-6.338-4.612c-.758-.552-.758-1.718 0-2.27l6.338-4.612C18.786 5.61 20 6.267 20 7.388z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.004 16.612c0 1.121-1.214 1.778-2.097 1.135l-6.339-4.612c-.757-.552-.757-1.718 0-2.27l6.339-4.612c.883-.643 2.097.014 2.097 1.135z"
})));
export default SvgIcFillBack;